export const commonTranslationES = {
  'Failed to get data': 'Failed to get data',
  'Yes': 'Yes',
  'No': 'No',
  'Close': 'Close',
  'Cancel': 'Cancel',
  'Save': 'Save',
  'Delete': 'Delete',
  'Confirmation Message': 'Confirmation Message',
  'Individual Data Folders': 'Individual Data Folders',
  'Export': 'Export',
  'Failed to move folder': 'Failed to move folder',
  'New Folder': 'New Folder',
  'Delete Folder': 'Delete Folder',
  'Delete Format': 'Delete Format',
  'Load': 'Load',
  'There are not folders': 'There are not folders',
  'Format Name': 'Format Name',
  'Type': 'Type',
  'Field': 'Field',
  'Path': 'Path',
  'Description': 'Description',
  'Name': 'Name',
  'dontSave': "Don't save",
};